import { StoreModel } from '../../models/Index'

export default function homeButtonHide(Store: StoreModel, event: any) {
    Store.setValue({ hideBackToHome: true });
}
